import { Link, useLocation } from "react-router-dom";
import { Package, BookMarked } from "lucide-react";

// Shared sub-navigation for the Beholdning section (Pantry + Varekartotek)
export default function PantrySubTabs() {
  const { pathname } = useLocation();
  const isPantry = pathname === "/pantry";
  const isCatalog = pathname === "/catalog";
  const baseClass =
    "inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-colors border";
  const activeClass = "bg-navy-800 text-white border-navy-800";
  const idleClass = "bg-white text-stone-600 border-stone-200 hover:border-stone-300 hover:text-stone-800";
  return (
    <nav className="flex items-center gap-2 mb-6 print-hide" data-testid="pantry-subtabs">
      <Link to="/pantry" className={`${baseClass} ${isPantry ? activeClass : idleClass}`} data-testid="tab-pantry">
        <Package className="h-4 w-4" /> Beholdning
      </Link>
      <Link to="/catalog" className={`${baseClass} ${isCatalog ? activeClass : idleClass}`} data-testid="tab-catalog">
        <BookMarked className="h-4 w-4" /> Varekartotek
      </Link>
    </nav>
  );
}
